// Newsletter tabs
document.querySelectorAll(".newsletter-tab").forEach((tab) => {
  tab.addEventListener("click", () => {
    document
      .querySelectorAll(".newsletter-tab")
      .forEach((t) => t.classList.remove("active"));
    document
      .querySelectorAll(".newsletter-content")
      .forEach((c) => c.classList.remove("active"));
    tab.classList.add("active");
    document
      .getElementById(
        tab.id === "tab-join-btn" ? "tab-join-content" : "tab-don-content",
      )
      .classList.add("active");
  });
  tab.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") tab.click();
  });
});

// Slider
const slider = document.querySelector(".evenement-slider");
const cards = Array.from(document.querySelectorAll(".evenement-card"));
const sliderContainer = document.querySelector(".evenement-slider-container");
let current = 0;

if (slider && cards.length > 0) {
  // ← ajoute cette condition
  function getStep() {
    if (cards.length < 2) {
      return (cards[0]?.offsetWidth ?? 420) + 40;
    }
    return cards[1].offsetLeft - cards[0].offsetLeft;
  }

  function updateSlider() {
    const step = getStep();
    const anchor = cards[0].offsetLeft;
    cards.forEach((card, i) => {
      card.classList.toggle("active", i === current);
      card.classList.toggle("next", i === (current + 1) % cards.length);
    });
    slider.style.transform = `translateX(${-(current * step + anchor)}px)`;
  }

  const prevBtn = document.querySelector(
    ".evenement-arrows .button-dark:first-child",
  );
  const nextBtn = document.querySelector(
    ".evenement-arrows .button-dark:last-child",
  );

  if (prevBtn && nextBtn) {
    prevBtn.onclick = (e) => {
      e.preventDefault();
      current = (current - 1 + cards.length) % cards.length;
      updateSlider();
    };
    nextBtn.onclick = (e) => {
      e.preventDefault();
      current = (current + 1) % cards.length;
      updateSlider();
    };
  }

  window.addEventListener("resize", () => updateSlider());
  updateSlider();
} // ← ferme ici

// Burger menu
const burger = document.querySelector(".burger");
const navLinks = document.getElementById("nav-links");

if (burger && navLinks) {
  burger.addEventListener("click", () => {
    navLinks.classList.toggle("active");
    burger.classList.toggle("active");
  });
}

// Financement popup
const popup = document.querySelector(".financement-popup");
const content = document.querySelector(".financement-popup-content");
const closeBtn = document.querySelector(".financement-popup-top a");
const flag = document.querySelector(".flag");

function closePopup() {
  popup.classList.add("closing");
  popup.addEventListener(
    "animationend",
    () => {
      popup.classList.add("hidden");
      popup.classList.remove("closing");
    },
    { once: true },
  );
}

flag.addEventListener("click", (e) => {
  e.preventDefault();
  popup.classList.remove("hidden");
});

closeBtn.addEventListener("click", (e) => {
  e.preventDefault();
  closePopup();
});

popup.addEventListener("click", () => {
  closePopup();
});

content.addEventListener("click", (e) => {
  e.stopPropagation();
});
